<div class="task-basic-preview-data">
  <div class="d-flex flex-column">
    @if (!!service.task?.parent?.description) {
      <div class="pointer parent-link" (click)="openParentPreview(service.task?.parent)">
        <svg-icon src="/assets/img/arrow-left-blue.svg" [svgStyle]="{ width: '18px', height: '18px' }" />
        <span [title]="service.task?.parent?.description">
          {{ service.task?.parent?.description }}
        </span>
      </div>
    }

    @if (service?.task?.type === TaskType.TYPE_CHANGE) {
      <form [formGroup]="service.form" class="mb-4">
        <div class="task-basic-panel">
          <div class="new-select-label">{{ 'Projects.changeTypeLabel' | translate }}</div>
          <ng-select
            ngSelectExtension
            class="w-100 new-select"
            [items]="changeTypes"
            [placeholder]="'Projects.changeTypePlaceholder' | translate"
            [notFoundText]="'Projects.notFoundTextTaskGroup' | translate"
            [tabIndex]="-1"
            bindLabel="name"
            bindValue="id"
            [searchable]="false"
            [formControlName]="service.TASK_SIDENAV_FORM.changeType"
          />
        </div>
      </form>
    }

    <div class="task-basic-panel d-flex flex-column mb-4">
      <div class="d-flex flex-row align-items-center">
        <div class="task-basic-preview-data__title-column">
          @if (editingTitle) {
            <div class="task-basic-preview-data__inline-edit">
              <input-v2
                #titleInput
                [formControl]="titleEditControl"
                [placeholder]="titlePlaceholderKey | translate"
                (onKeydown)="onEnter($event)"
              />
            </div>
          } @else {
            <div
              class="task-name"
              [class.task-name--editable]="allowInlineEditing"
              (click)="startTitleEdit()"
            >
              {{ service?.task?.description }}
            </div>
          }
        </div>
      </div>

      @if (editingDescription) {
        <div class="task-basic-preview-data__description-editor">
          <quill-editor
            #descriptionEditor
            [formControl]="contentEditControl"
            [bounds]="'.quill-custom-img-size'"
            [modules]="descriptionModules"
            [formats]="quillFormats"
            class="quill-v2 quill-custom-img-size quill-custom-matcher"
            [placeholder]="'Projects.enterDescription-task' | translate"
          />
        </div>
      } @else if (shouldShowInlineDescriptionPlaceholder) {
        <div class="description description--placeholder pointer" (click)="startDescriptionEdit()">
          <span>{{ 'Projects.enterDescription-task' | translate }}</span>
          @if (allowInlineEditing) {
            <img draggable="false" src="/assets/img/pencil-icon.svg" alt="Edit" />
          }
        </div>
      } @else if (shouldShowDescriptionValue) {
        <div
          class="description description--editable"
          [class.pointer]="allowInlineEditing"
          (click)="startDescriptionEdit()"
        >
          <div class="value ql-editor" [innerHTML]="service.safeContent"></div>
        </div>
      }
    </div>

    @if (!isProcessTaskContext) {
      <form [formGroup]="service.form" class="mb-4">
        <div class="task-basic-panel task-basic-preview-data__meta-panel">
          <div>
            <div class="task-basic-preview-data__label-row">
              <div class="new-select-label mb-0">{{ 'Projects.projectName' | translate }}</div>
              @if (service?.task?.project?.id) {
                <button
                  type="button"
                  class="task-basic-preview-data__project-link"
                  (click)="navigateToProject(service?.task?.project)"
                >
                  <svg-icon [src]="'/assets/img/ic-external-link.svg'" />
                </button>
              }
            </div>

            <project-selection
              class="w-100"
              [disabled]="!!service.task?.parent || !!service.connectedTask || !!service?.task?.isDeleted"
              [isFieldRequired]="!!service.isConfigChange || isProjectRequired"
              [requiredid]="service.projectID"
              [form]="service.form"
              [addTag]="canProjectAdd"
              [controlName]="service.TASK_SIDENAV_FORM.projectId"
              (onProjectClear)="resetProjectControl()"
            />
          </div>

          <div *ngIf="service?.task?.type !== TaskType.TYPE_CHANGE">
            <div class="new-select-label">{{ 'Projects.taskGroupLabel' | translate }}</div>
            <ng-select
              ngSelectExtension
              class="w-100 new-select"
              [items]="taskGroups$ | async"
              [placeholder]="'Projects.chooseTaskGroup' | translate"
              [notFoundText]="'Projects.notFoundTextTaskGroup' | translate"
              [tabIndex]="-1"
              bindLabel="name"
              bindValue="id"
              [searchable]="false"
              [formControlName]="service.TASK_SIDENAV_FORM.groupId"
            />
          </div>
        </div>
      </form>
    }
  </div>

  <ng-container *ngIf="!!service.connectedTask && service.isPreview">
    <div class="d-flex justify-content-between align-items-center task-basic-preview-data__connected-task">
      <span>{{ service.connectedTask.description }}</span>
      <svg-icon
        class="cursor-pointer"
        (click)="taskManager.previewTask(service.task?.linkedChange)"
        [src]="'/assets/img/ic-external-link.svg'"
        [svgStyle]="{ width: '16px', height: '16px' }"
      />
    </div>
  </ng-container>

  <ng-container *ngIf="service.isConfigChange && service.isPreview">
    <task-changes-summary />
  </ng-container>

  <div *ngIf="!!service.isConfigChange && !storage?.Employee?.isClient" class="mb-4 mt-4 task-basic-panel">
    <div class="new-select-label red">{{ 'Projects.internalNote' | translate }}</div>
    <div class="relative">
      @if (editingInternalNote) {
        <div class="task-basic-preview-data__description-editor">
          <quill-editor
            #internalNoteEditor
            [modules]="internalNoteModules"
            [formats]="quillFormats"
            [placeholder]="'Projects.enterInternalNote' | translate"
            [formControl]="internalNoteEditControl"
            [bounds]="'.internal-note-bound'"
            [readOnly]="!!service?.task?.isDeleted || !allowInlineEditing"
            class="quill-v2 quill-custom-img-size internal-note-bound"
            (onBlur)="saveInternalNoteEdit()"
          />
        </div>
      } @else if (shouldShowInternalNoteValue) {
        <div
          class="description description--editable"
          [class.pointer]="allowInlineEditing"
          (click)="startInternalNoteEdit()"
        >
          <div class="value ql-editor" [innerHTML]="service.safeContentInternalNote"></div>
        </div>
      } @else {
        <div class="description description--placeholder pointer" (click)="startInternalNoteEdit()">
          <span>{{ 'Projects.enterInternalNote' | translate }}</span>
          @if (allowInlineEditing) {
            <img draggable="false" src="/assets/img/pencil-icon.svg" alt="Edit" />
          }
        </div>
      }
    </div>
  </div>

  <div class="mb-4 mt-4">
    <task-sidenav-blue />
  </div>
</div>
